<header class="navbar">
  <a href="#main-content" class="skip-to-main" (click)="onSkipToMainClick($event)" (keydown)="skipToMain($event)">
    Skip to main content
    <img src="/assets/icons/right-arrow.svg" alt="Right arrow" />
  </a>
  <a routerLink="/">
    <img src="/assets/images/futurenav-logo.png" alt="Future Nav – Compass logo" />
  </a>
  @if (showMenu) {
    @if (showMenuItems) {
      <nav aria-label="Main Menu" class="menu">
          @for (item of menuItems; track $index) {
            <a
              class="menu-item"
              [class.active]="item.active"
              [routerLink]="menuRoutes[$index][0]"
              (click)="changeTab($index)"
              [attr.aria-label]="item.name"
              [attr.aria-current]="item.active ? 'page' : null"
            >
              <p class="item-name">{{ item.name }}</p>
            </a>
          }
      </nav>
    }
    <div class="user">
    <!-- {{userProfile?.firstName || ''}} 'account' -->
      <button
        #dropdownTrigger
        class="user-dropdown"
        type="button"
        (click)="toggleDropdown()"
        [attr.aria-expanded]="isDropdownOpen.toString()"
        aria-haspopup="menu"
        aria-controls="user-dropdown-menu"
        [attr.aria-label]="(userProfile?.firstName || '') + ' account menu'"
        (keydown)="onDropdownKeydown($event)"
      >
        <div class="dropdown-trigger">
          <div class="profile">
            <div class="profile-icon">
              <img src="/assets/images/profile.svg" alt="profile" />
            </div>
            <p class="username">{{ (userProfile?.firstName || 'Loading...') | titlecase  }}</p>
          </div>
          <img 
            src="/assets/icons/chevron-right.svg" 
            alt="" 
            class="chevron" 
            [class.open]="isDropdownOpen" 
          />
        </div>
      </button>
      @if (isDropdownOpen) {
        <div id="user-dropdown-menu" class="dropdown-menu" role="menu" aria-label="User menu options">
          <div
            class="dropdown-item"
            routerLink="/profile"
            (click)="navigateToProfile()"
            tabindex="0"
            role="menuitem"
            (keydown)="onDropdownItemKeydown($event, 0)"
          >
            My Profile
          </div>
          <div class="dropdown-divider"></div>
          <div 
            class="dropdown-item sign-out" 
            (click)="signOut()" 
            tabindex="0" 
            role="menuitem" 
            (keydown)="onDropdownItemKeydown($event, 1)"
          >
            Sign Out
            <img src="/assets/icons/logout.svg" alt="" />
          </div>
        </div>
      }
    </div>
  } @else if (userLoggedIn) {
    <div class="user sign-out-item" (click)="signOut()" tabindex="0" role="button" aria-label="Sign Out" (keydown)="onSignOutKeydown($event)">
      Sign Out
      <img src="/assets/icons/logout.svg" alt="" />
    </div>
  }
</header>